import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useStaffDetails } from "../../../../../hooks/useDataHooks";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";

// Define column widths and headers for Human Resources - Responsive layout
const mobilized_quantity = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const Position = { xxl: 5, xl: 5, lg: 5, md: 5, sm: 12, xs: 12 };
const proposed_name = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 12, xs: 12 };
const replacement = { xxl: 3, xl: 3, lg: 3, md: 2, sm: 0, xs: 0 };
const status = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const remarks = { xxl: 5, xl: 5, lg: 5, md: 5, sm: 12, xs: 12 };

const headerLayout = [
  { ...Position, header: "Position required" },
  { ...proposed_name, header: "Proposed Name" },
  { ...replacement, header: "Replacement" },
  { ...mobilized_quantity, header: "Mobilized Quantity" },
  { ...status, header: "Mobilization (%)" },
  { ...remarks, header: "Remarks" },
];

const HumanResources = ({ match }) => {
  const { startDate, endDate } = useReportDateRange();
  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const history = useHistory();
  const {
    params: { packageId },
  } = match;
  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name || "";
  const contractId = procuringEntityPackage?.contract?.id;
  const { staffDetails, pagination, loading } = useStaffDetails(contractId, startDate, endDate, currentPage, pageSize);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [contractId]);
  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
    setActiveItem(null); 
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    setActiveItem(null); 
  };

  // const {
  //   params: { packageId },
  // } = match;
  // const { loading, staff } = useProcuringEntityPackage(packageId);

  // const mobilizedStaff = staff?.map(
  //   ({ proposed_name, replacement, status, remarks, position }) => {
  //     return { proposed_name, replacement, status, remarks, position };
  //   }
  // );

  return (
    <>
      <div style={{ padding: "16px" }}>
       <ActionBar actionButtonProp={{
          title: `${packageName || "==//=="}: Mobilized Staffs`,
          arrActions: [],
          buttons: [],
        }} />
        <div className="prst-table">
        <CustomList
          itemName="Staff Mobilization"
          showToolbar={false}
          items={staffDetails}
          page={currentPage}
          itemCount={pagination?.total || 0}
          loading={loading}
          headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id} // eslint-disable-line
              name={item?.position?.name || "==//=="}
              item={item}
              renderActions={() => {}}
              onClick={() => handleRowClick(item)}
              style={{
                backgroundColor:
                  activeItem?.position?.name === item.position?.name
                    ? "#f0f0f0"
                    : "transparent",
              }}
            >
              <Col
                {...Position}
                className="contentEllipse"
                data-label="Position Required"
                title={item?.position?.name || "==//=="}
              >
                {item?.position?.name?.length > 40 ? item?.position?.name.slice(0, 40) + "..." : item?.position?.name || "-"}
              </Col>

              <Col 
                {...proposed_name} 
                className="contentEllipse"
                data-label="Proposed Name"
              >
                {item?.proposed_name || "==//=="}
              </Col>

              <Col 
                {...replacement} 
                className="contentEllipse"
                data-label="Replacement"
              >
                  {item?.replacement || "==//=="}
              </Col>

              <Col
                {...mobilized_quantity}
                className="contentEllipse"
                data-label="Mobilized Quantity"
                title={item?.mobilized_quantity || "==//=="}
              >
                {item?.mobilized_quantity || "==//=="}
              </Col>
              
              <Col 
                {...status} 
                className="contentEllipse"
                data-label="Mobilization (%)"
              >
                {item?.status || "==//=="}
              </Col>
              
              <Col 
                {...remarks} 
                className="contentEllipse"
                data-label="Remarks"
              >
                {item?.remarks?.length > 40 ? item?.remarks.slice(0, 40) + "..." : item?.remarks || "==//=="}
              </Col>

              <button 
                className="view-card-details" 
                onClick={() => handleRowClick(item)}
              >
                View Details
              </button>
            </ListItem>
          )}
        />
        </div>
        
        <CustomPagination 
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </div>

      <Drawer
        title="Staff Details"
        placement="right"
        closable={true}
        onClose={handleCloseDrawer}
        visible={visible}
        width={520}
      >
        <p>
          <strong>Position:</strong> {activeItem?.position?.name || "==//=="}
        </p>
        <p>
          <strong>Proposed Name:</strong> {activeItem?.proposed_name || "==//=="}
        </p>
        <p>
          <strong>Replacement:</strong> {activeItem?.replacement || "==//=="}
        </p>
        <p>
          <strong>Mobilization Status (%):</strong> {activeItem?.status || "==//=="}
        </p>
        <p>
          <strong>Remarks:</strong> {activeItem?.remarks || "==//=="}
        </p>
        <p>
          <strong>Mobilized Quantity:</strong> {activeItem?.mobilized_quantity || "==//=="}
        </p>
        {activeItem?.position && (
          <>
            <p>
              <strong>Position Description:</strong> {activeItem.position.description || "==//=="}
            </p>
          </>
        )}
      </Drawer>
    </>
  );
};

export default HumanResources;
